export default __webpack_public_path__ + "static/media/arrow.cb428c95.png";